module.exports = __webpack_public_path__ + "img/5-leaving-home_v8e_loading.e15b8ab2.jpg";